import { updateJurisdictions } from './updateJurisdictionThunk';
export default updateJurisdictions;
